import React from 'react';

import type { IPriceRow } from 'shared/types/pricesTable';
import { formatPriceValue } from 'shared/utils/formatPriceValue';
import * as styles from '../../styles.css';

interface IPriceCategorySectionProps {
  categoryName: string;
  rows: IPriceRow[];
}

export const PriceCategorySection: React.FC<IPriceCategorySectionProps> = ({ categoryName, rows }) => (
  <>
    <tr className={styles['prices-table__category-row']}>
      <td colSpan={4} className={styles['prices-table__category']}>
        {categoryName}
      </td>
    </tr>
    {rows.map((row, index) => (
      <tr key={index} className={styles['prices-table__data-row']}>
        <td className={styles['prices-table__cell']}>{row.name}</td>
        <td className={styles['prices-table__cell']}>{formatPriceValue(row.bidPerView, row.bidPerViewFormat)}</td>
        <td className={styles['prices-table__cell']}>{formatPriceValue(row.minDailyLimit, row.minDailyLimitFormat)}</td>
        <td className={styles['prices-table__cell']}>{formatPriceValue(row.bidStep, row.bidStepFormat)}</td>
      </tr>
    ))}
  </>
);
